import { render, staticRenderFns } from "./stake-lp-calculator.vue?vue&type=template&id=2fb65b14&scoped=true&"
import script from "./stake-lp-calculator.vue?vue&type=script&lang=ts&"
export * from "./stake-lp-calculator.vue?vue&type=script&lang=ts&"
import style0 from "./stake-lp-calculator.vue?vue&type=style&index=0&id=2fb65b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb65b14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VImg,VSheet,VTextField})
